import { Flow, StatGroup } from '../../services/viva/constants';

export type AddOnMarketingTextType = {
  byFlow: {
    [key in Flow]: {
      [key in StatGroup]?: {
        title: string;
        copy: string;
      };
    };
  };
  byStatGroup: {
    [key in StatGroup]: {
      title: string;
      copy: string;
    };
  };
};

export default {
  byFlow: {
    [Flow.TOR_GA]: {
      [StatGroup.THE_BEAM]: {
        title: 'The Beam',
        copy: 'Be lifted 12 feet above the deck to recreate the iconic "Lunch atop a Skyscraper" photo. Purchase one per person. Please note, each Beam seats 7 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Guests must be 52 inches (~132 cm) or taller to ride alone. If under 52 inches, guests must be a minimum of 42 inches (~107 cm) and be accompanied by an adult. All guests must have tickets. The maximum weight limit is 300 lbs. (~136 kg.)',
      },
      [StatGroup.CHAMPAGNE_TOAST]: {
        title: 'Champagne Toast',
        copy: 'Treat yourself to a sky-high toast at The Weather Room, a quintessential New York City destination, offering a panoramic view from the 67th floor of Top of the Rock.  Choose from a 3 Oz. Pour of Champagne (for 21 & older) or a non-alcoholic option to raise a glass during your visit to Top of the Rock. Limit one per person.',
      },
      [StatGroup.PHOTO_PACKAGE]: {
        title: 'Photo Pass',
        copy: 'An experience to remember! Receive all digital photos taken by professional photographers throughout your visit. Buy now and save 25%.',
      },
      [StatGroup.SANTA_PHOTO]: {
        title: 'Santa Photo',
        copy: "Bring the whole family for a one-of-a-kind Santa Experience! Capture the magic of the season with a heartwarming photo with Santa Claus himself on Top of the Rock's signature Beam (remains stationary on the ground). Watch your little ones' faces light up with joy as they share their holiday wishes and dreams with the man in the red suit. With the purchase of Photo Pass, guests receive all digital photos taken by professional photographers throughout your visit as well! Buy now and save 20%.",
      },
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.FIVE_ACRES]: {
        title: '5 Acres',
        copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
      },
      [StatGroup.SKYLIFT]: {
        title: 'Skylift',
        copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
      },
    },
    [Flow.TOR_EXPRESS]: {
      [StatGroup.THE_BEAM]: {
        title: '',
        copy: `Be lifted 12 feet above the deck to recreate the iconic 'Lunch atop a Skyscraper' photo. Purchase one per person. Please note, each Beam seats 7 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass.`,
      },
      [StatGroup.CHAMPAGNE_TOAST]: {
        title: 'Champagne Toast',
        copy: 'Treat yourself to a sky-high toast at The Weather Room, a quintessential New York City destination, offering a panoramic view from the 67th floor of Top of the Rock.  Choose from a 3 Oz. Pour of Champagne (for 21 & older) or a non-alcoholic option to raise a glass during your visit to Top of the Rock. Limit one per person.',
      },
      [StatGroup.PHOTO_PACKAGE]: {
        title: 'Photo Pass',
        copy: 'An experience to remember! Receive all digital photos taken by professional photographers throughout your visit. Buy now and save 25%.',
      },
      [StatGroup.SANTA_PHOTO]: {
        title: 'Santa Photo',
        copy: "Bring the whole family for a one-of-a-kind Santa Experience! Capture the magic of the season with a heartwarming photo with Santa Claus himself on Top of the Rock's signature Beam (remains stationary on the ground). Watch your little ones' faces light up with joy as they share their holiday wishes and dreams with the man in the red suit. With the purchase of Photo Pass, guests receive all digital photos taken by professional photographers throughout your visit as well! Buy now and save 20%.",
      },
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.FIVE_ACRES]: {
        title: '5 Acres',
        copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
      },
      [StatGroup.SKYLIFT]: {
        title: 'Skylift',
        copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
      },
    },
    [Flow.RC_ROCK_PASS]: {
      [StatGroup.THE_BEAM]: {
        title: '',
        copy: `Be lifted 12 feet above the deck to recreate the iconic 'Lunch atop a Skyscraper' photo. Purchase one per person. Please note, each Beam seats 7 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass.`,
      },
      [StatGroup.CHAMPAGNE_TOAST]: {
        title: 'Champagne Toast',
        copy: 'Treat yourself to a sky-high toast at The Weather Room, a quintessential New York City destination, offering a panoramic view from the 67th floor of Top of the Rock.  Choose from a 3 Oz. Pour of Champagne (for 21 & older) or a non-alcoholic option to raise a glass during your visit to Top of the Rock. Limit one per person.',
      },
      [StatGroup.PHOTO_PACKAGE]: {
        title: 'Photo Pass',
        copy: 'An experience to remember! Receive all digital photos taken by professional photographers throughout your visit. Buy now and save 25%.',
      },
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.FIVE_ACRES]: {
        title: '5 Acres',
        copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
      },
      [StatGroup.SKYLIFT]: {
        title: 'Skylift',
        copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
      },
    },
    [Flow.RINK]: {
      [StatGroup.SKATE_RENTAL]: {
        title: 'Skate Rental',
        copy: 'Reserve your rental skates in advance. Skates are required on the ice. Penguin Skate Aids may be rented on site.',
      },
      [StatGroup.HOT_COCOA]: {
        title: 'Cookie and Hot Cocoa',
        copy: 'Gourmet hot chocolate and treat',
      },
      [StatGroup.BEANIE]: {
        title: 'Beanie',
        copy: "Stay warm with this season's commemorative beanie. Buy now and save 20%.",
      },
      [StatGroup.TREE_PHOTO]: {
        title: 'Tree Photo',
        copy: 'Purchase one photo for your group',
      },
      [StatGroup.ORNAMENT]: {
        title: 'Rockefeller Center Ornament',
        copy: 'Relive the enchantment of Rockefeller Center every holiday season with our exclusive ornament. Featuring a detailed depiction of the iconic Rockefeller Center Tree, this keepsake embodies the magic of your visit.',
      },
    },
    [Flow.RINK_VIP]: {
      [StatGroup.SKATE_RENTAL]: {
        title: 'Skate Rental',
        copy: 'Reserve your rental skates in advance. Skates are required on the ice.',
      },
      [StatGroup.BEANIE]: {
        title: 'Beanie',
        copy: "Stay warm with this season's commemorative beanie. Buy now and save 20%.",
      },
      [StatGroup.ORNAMENT]: {
        title: 'Rockefeller Center Ornament',
        copy: 'Relive the enchantment of Rockefeller Center every holiday season with our exclusive ornament. Featuring a detailed depiction of the iconic Rockefeller Center Tree, this keepsake embodies the magic of your visit.',
      },
      [StatGroup.TREE_PHOTO]: {
        title: 'Tree Photo',
        copy: 'Purchase one photo for your group',
      },
    },
    [Flow.TOR_VIP]: {
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.SKYLIFT]: {
        title: 'Skylift',
        copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
      },
    },
    [Flow.TOR_VIP_ROCKSTAR]: {
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.FIVE_ACRES]: {
        title: '5 Acres',
        copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
      },
      [StatGroup.SKYLIFT]: {
        title: 'Skylift',
        copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
      },
    },
    [Flow.RC_ROCK_PASS_VIP_HOLIDAY]: {
      [StatGroup.RESTAURANT_JUPITER]: {
        title: '3 Course Meal at Jupiter',
        copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
      },
      [StatGroup.FIVE_ACRES]: {
        title: '5 Acres',
        copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
      },
    },
    [Flow.THE_BEAM_PASS]: {
      [StatGroup.SANTA_PHOTO]: {
        title: 'Santa Photo',
        copy: "Bring the whole family for a one-of-a-kind Santa Experience! Capture the magic of the season with a heartwarming photo with Santa Claus himself on Top of the Rock's signature Beam (remains stationary on the ground). Watch your little ones' faces light up with joy as they share their holiday wishes and dreams with the man in the red suit. With the purchase of Photo Pass, guests receive all digital photos taken by professional photographers throughout your visit as well! Buy now and save 20%.",
      },
    },
    [Flow.RC_TOUR]: {
      [StatGroup.TREE_PHOTO]: {
        title: 'Tree Photo',
        copy: 'Purchase one photo for your group',
      },
    },
  },
  byStatGroup: {
    [StatGroup.THE_BEAM]: {
      title: 'The Beam',
      copy: `Be lifted 12 feet above the deck to recreate the iconic 'Lunch atop a Skyscraper' photo. Purchase one per person. Please note, each Beam seats 7 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass.`,
    },
    [StatGroup.CHAMPAGNE_TOAST]: {
      title: 'Champagne Toast',
      copy: 'Treat yourself to a sky-high toast at The Weather Room, a quintessential New York City destination, offering a panoramic view from the 67th floor of Top of the Rock.  Choose from a 3 Oz. Pour of Champagne (for 21 & older) or a non-alcoholic option to raise a glass during your visit to Top of the Rock. Limit one per person.',
    },
    [StatGroup.SANTA_PHOTO]: {
      title: 'Santa Photo',
      copy: "Bring the whole family for a one-of-a-kind Santa Experience! Capture the magic of the season with a heartwarming photo with Santa Claus himself on Top of the Rock's signature Beam (remains stationary on the ground). Watch your little ones' faces light up with joy as they share their holiday wishes and dreams with the man in the red suit. With the purchase of Photo Pass, guests receive all digital photos taken by professional photographers throughout your visit as well! Buy now and save 20%.",
    },
    [StatGroup.BUNNY_PHOTO]: {
      title: 'Easter Bunny Photo Pass',
      copy: "Celebrate the magic of spring with a unique photo opportunity alongside the Easter Bunny on Top of the Rock's signature Beam (remains stationary on the ground). Available as an add-on to General Admission Top of the Rock tickets at select dates and times. Includes the full observation deck photo pass ($40 value).  Buy now and save 25%",
    },
    [StatGroup.PHOTO_PACKAGE]: {
      title: 'Photo Pass',
      copy: 'An experience to remember! Receive all digital photos taken by professional photographers throughout your visit. Buy now and save 25%.',
    },
    [StatGroup.SKATE_RENTAL]: {
      title: 'Skate Rental',
      copy: 'Reserve your rental skates in advance. Skates are required on the ice.',
    },
    [StatGroup.HOT_COCOA]: {
      title: 'Cookie and Hot Cocoa',
      copy: 'Gourmet hot chocolate and treat',
    },
    [StatGroup.BEANIE]: {
      title: 'Beanie',
      copy: "Stay warm with this season's commemorative beanie. Buy now and save 20%.",
    },
    [StatGroup.ORNAMENT]: {
      title: 'Rockefeller Center Ornament',
      copy: 'Relive the enchantment of Rockefeller Center every holiday season with our exclusive ornament. Featuring a detailed depiction of the iconic Rockefeller Center Tree, this keepsake embodies the magic of your visit.',
    },
    [StatGroup.TREE_PHOTO]: {
      title: 'Tree Photo',
      copy: 'Purchase one photo for your group',
    },
    [StatGroup.RESTAURANT_JUPITER]: {
      title: 'Jupiter',
      copy: "Hailed by Vogue as 'a scene and dining room you want to… without question - indulge in.' Enjoy an exclusive prix fixe menu from Jupiter, one of Manhattan's hottest new restaurants specializing in Italian food and drink and located adjacent to Top of the Rock. Reserve your table now for this in-demand hot spot.",
    },
    [StatGroup.FIVE_ACRES]: {
      title: '5 Acres',
      copy: 'A 2-Course Prix Fixe meal at an easygoing and lively spot for breakfast, lunch, dinner, and drink. 5 Acres’ menu centers around classic American tavern cuisine paired with the best possible expression of seasonal ingredients. Includes any Sando, non-alcoholic beverage, and Dessert from the Prix Fixe Menu.  (Your reservation will be booked approximately within 2 hours of your Top of the Rock or Rink visit start time).',
    },
    [StatGroup.SKYLIFT]: {
      title: 'Skylift',
      copy: 'Ascend three stories above Top of the Rock’s 70th floor observation deck on a revolving, open-air glass platform for extraordinary 360-degree views of the city and beyond. Purchase one ticket per person. Please note, Skylift can hold up to 13 guests and may include guests from multiple parties. To guarantee a private experience, please upgrade to the VIP Pass. Skylift video is included with the Photo Pass.',
    },
  },
} as AddOnMarketingTextType;
